<template>
  <div class="consult-container">
    <div class="search-container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户名称">
          <el-input v-model="formInline.memberName" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="用户" align="center">
        </el-table-column>
        <el-table-column prop="endDate" label="申请时间" align="center" :formatter="dateFormat">
        </el-table-column>
        <el-table-column prop="instanceName" align="center" label="实例名">
        </el-table-column>
        <el-table-column prop="cpuCount" align="center" label="CPU">
        </el-table-column>
        <el-table-column prop="diskSize" align="center" label="存储">
        </el-table-column>
        <el-table-column prop="memory" align="center" label="内存">
        </el-table-column>
        <el-table-column prop="bandWidth" align="center" label="带宽">
        </el-table-column>
        <el-table-column prop="serverStatus" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.serverStatus === 0">已通过</span>
            <span v-else-if="scope.row.serverStatus === 1">已拒绝</span>
            <span v-else-if="scope.row.serverStatus === 2">审核中</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button v-if="scope.row.serverStatus === 2" type="text" size="small" class="ml-10"
              @click="handleReviewClick(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核功能 -->
    <el-drawer title="审核" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
      <el-form ref="form" :model="drawerForm" label-width="120px">
        <el-form-item label="实际到账金额">
          <el-input v-model="drawerForm.price" placeholder="请输入实际到账金额"></el-input>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="drawerForm.result">
            <el-radio :label="0">通过</el-radio>
            <el-radio :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="drawerForm.result === 1">
          <el-input type="textarea" v-model="drawerForm.reason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitReview" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getResourceList } from '@/api/resourcesManagement'
import { getResourceReview } from '@/api/operationsManagement'
import moment from 'moment';
export default {
  name: 'AdminStaticsResourceApplication',
  data() {
    return {
      tableLoading: false,
      drawer: false,
      drawerForm: {
        result: 0,
        reason: '',
        price: '',
      },
      record: {},
      formInline: {
        memberName: ''
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      tableData: []
    };
  },

  mounted() {
    this.loadData()
  },

  methods: {
    cancelForm() {
      this.drawer = false
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.askDate).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleReviewClick(row) {
      this.drawer = true
      this.record = row
    },
    // 审核-确定
    async submitReview() {
      const params = {
        memberId: this.record.memberId,
        result: this.drawerForm.result,
        serverInstanceId: this.record.id,
        reviewType: 7,
        receiveMoney: Number(this.drawerForm.price)
      }
      if (this.drawerForm.result === 1) {
        params.reason = this.drawerForm.reason
      }
      await getResourceReview({
        ...params
      }).then(() => {
        this.$message.success('审核成功')
        this.drawer = false
        this.record = {}
        this.loadData()
      })
    },
    onSubmit() {
      this.loadData()
    },
    async loadData() {
      this.tableLoading = true
      const params = {}
      if (this.formInline.memberName) {
        params.memberName = this.formInline.memberName
      }
      await getResourceList({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params,
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.content
        this.pagination.total = res.data.totalElements
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .ml-10 {
    margin: 0 10px;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>
<style lang="scss">
.el-popconfirm__main {
  margin: 10px 0;
}
</style>